<div class="main-container">
  <div class="data-table-wrapper">

    <ngx-datatable
      #datatable
      class="material"
      [rows]="displayReceipts"
      [limit]="displayReceipts.length || 1"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="0"
      [rowHeight]="'auto'"
      [scrollbarH]="true"
      [scrollbarV]="false"
      [rowClass]="getRowClass"
      [trackByProp]="'id'"
      [sorts]="sortColumn ? [{prop: sortColumn, dir: sortDirection}] : []"
      (sort)="onSort($event)">

      <!-- Expand/Collapse Column -->
      <ngx-datatable-column
        [width]="60"
        [resizeable]="false"
        [sortable]="false"
        [draggable]="false"
        [canAutoResize]="false">
        <ng-template ngx-datatable-cell-template let-row="row" let-expanded="expanded">
          <div (click)="$event.stopPropagation()">
            @if (row._isGroupHeader && row._groupSize > 1) {
              <div class="expand-cell">
                <div
                  class="expand-button-wrapper"
                  (click)="onExpandButtonClick($event, row._docId)">
                  <mat-icon class="expand-icon">{{ row._isExpanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                </div>
              </div>
            }
            @if (row._isGroupChild) {
              <div class="child-indent"></div>
            }
          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Configurable Data Columns -->
      @for (col of configColumns; track col) {
        <ngx-datatable-column
          [name]="col.label"
          [prop]="col.key"
          [width]="col.colWidth || 150"
          [resizeable]="true"
          [sortable]="col.sortable || false">
          <ng-template ngx-datatable-cell-template let-row="row" let-value="value" let-rowIndex="rowIndex">
            <div [class.group-child-cell]="row._isGroupChild" (click)="onRowCellClick(row)">
              @switch (col.key) {
                @case ('stage') {
                  <div [innerHTML]="getStage(row)"></div>
                }
                @case ('decision') {
                  <div [innerHTML]="getDecisionWithStyling(row)"></div>
                }
                @case ('createDate') {
                  <div [innerHTML]="getDateWithNewIndicator(row)"></div>
                }
                @case ('userPhoneNo') {
                  <div [innerHTML]="highlightText(formatPhoneNumber(row.userPhoneNo))"></div>
                }
                @case ('docId') {
                  <div>
                    <div [innerHTML]="highlightText(row.docId)"></div>
                  </div>
                }
                @case ('campaignName') {
                  <div>
                    @if (row._isGroupHeader && row._campaignCount > 1) {
                      <span>{{ row._campaignCount }} Campaigns</span>
                    }
                    @if (!row._isGroupHeader || row._campaignCount === 1) {
                      <span [innerHTML]="highlightText(row.campaignName)"></span>
                    }
                  </div>
                }
                @case ('tags') {
                  <div [innerHTML]="getTags(row)"></div>
                }
                @case ('meta.warnings') {
                  <div [innerHTML]="getWarnings(row)"></div>
                }
                @default {
                  @if (col.format?.type === 'date') {
                    <div>{{ value | date: 'MMM dd, yyyy' }}</div>
                  } @else if (!col.displayLabelHandler && !col.format) {
                    <div>{{ getValue(row, col.key) }}</div>
                  }
                }
              }
            </div>
          </ng-template>
        </ngx-datatable-column>
      }
    </ngx-datatable>
  </div>

  <app-receipt-filters #filtersPanel (search)="onSearch($event)"></app-receipt-filters>
  <app-receipt-panel #detailPanel [receipt]="selectedReceipt"></app-receipt-panel>
</div>
